import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { Alert, Button, Stack, TextField } from '@mui/material';
// hooks
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

ResetPasswordForm.propTypes = {
  email: PropTypes.string,
  onSent: PropTypes.func,
  onGetEmail: PropTypes.func,
};

export default function ResetPasswordForm({
  email,
  onSent,
  onGetEmail,
  extendSession,
}) {
  const { resetPassword } = useAuth();

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email('Email must be a valid email address.')
      .required('Email is required.'),
  });

  const formik = useFormik({
    initialValues: {
      email: email || '',
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      try {
        const response = await resetPassword(values.email);
        const data = await response.json();
        if (response.status === 200 || response.status === 404) {
          onSent();
          onGetEmail(values.email);
        } else if (response.status === 429 && data?.detail) {
          setErrors({ afterSubmit: data.detail });
        } else {
          setErrors({ afterSubmit: 'Something went wrong.' });
        }
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setErrors({ afterSubmit: 'Something went wrong.' });
        setSubmitting(false);
      }
    },
  });

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          {errors.afterSubmit && (
            <Alert severity="error">{errors.afterSubmit}</Alert>
          )}

          <TextField
            fullWidth
            {...getFieldProps('email')}
            disabled={extendSession}
            type="email"
            label="Email Address"
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />

          <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Reset Password
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
